import { render, staticRenderFns } from "./requestAccess.vue?vue&type=template&id=3e547299&scoped=true"
import script from "./requestAccess.vue?vue&type=script&lang=js"
export * from "./requestAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e547299",
  null
  
)

export default component.exports